module.exports = __webpack_public_path__ + "static/img/10.ff7655f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/10.png
// module id = E64Q
// module chunks = 0